import styled from 'styled-components';

/**
 * TODO: Consider consolidate headings, captions, etc. into a single typography
 *       component. Also globally set the default font color to be pleather.
 */

export const H1 = styled.h1`
  color: var(--heading-primary);
  font-weight: var(--bold);
  font-size: var(--xx-large);
  line-height: 1.5em;
  letter-spacing: -0.0025em;
`;

export const H2 = styled.h2`
  color: var(--heading-primary);
  font-weight: var(--normal);
  font-size: var(--x-large);
  line-height: 1.5em;
  letter-spacing: 0;
`;

export const H3 = styled.h3`
  color: var(--heading-primary);
  font-weight: var(--semi-bold);
  font-size: var(--large);
  line-height: 1.5em;
  letter-spacing: 0;
`;

export const H4 = styled.h4`
  color: var(--heading-primary);
  font-weight: var(--semi-bold);
  font-size: 17px;
  line-height: 1.5em;
  letter-spacing: -0.0025em;
`;

export const H5 = styled.h5`
  color: var(--heading-primary);
  font-weight: var(--semi-bold);
  font-size: var(--small);
  line-height: 1.8em;
  letter-spacing: 0.05em;
  text-transform: uppercase;
`;
